import { render, staticRenderFns } from "./RightInfo.vue?vue&type=template&id=3f185ef8&"
import script from "./RightInfo.vue?vue&type=script&lang=js&"
export * from "./RightInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports